import { roundFloatTo } from '../utils'

export const useFormatToBigBlindMultiple = (bigBlind: number) => {
  if (bigBlind === undefined) {
    throw new Error('There is no bigBlind for formatToBigBlinds.')
  }

  const formatToBigBlinds = (amount: number) => {
    if (amount === 0) return 0
    return roundFloatTo(amount / bigBlind, 2)
  }

  const formatToCurrency = (amountInBigBlinds: number) => {
    if (amountInBigBlinds === 0) return 0
    return roundFloatTo(amountInBigBlinds * bigBlind, 2)
  }

  return {
    formatToBigBlinds,
    formatToCurrency,
  }
}
